<template>
    <div class="tab_bar">
        <div class="mdc-tab-bar view-tab-bar shadow2" role="tablist" id="examViewSubTab" ref="surveyViewTab">
            <div class="mdc-tab-scroller">
                <div class="mdc-tab-scroller__scroll-area mdc-tab-scroller__scroll-area--scroll mgb-000">
                    <div class="mdc-tab-scroller__scroll-content">
                        <button class="mdc-tab mdc-tab--active" role="tab" tabindex="0" @click="changeTabType('Information')" style="width:50%">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('224')}}
                                    <!-- 설문지 정보 -->
                                </span>
                            </span>
                            <span class="mdc-tab-indicator mdc-tab-indicator--active">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button>
                        <button class="mdc-tab" role="tab" tabindex="1" @click="changeTabType('Reward')" style="width:50%">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('225')}}
                                    <!-- 리워드 -->
                                </span>
                            </span>
                            <span class="mdc-tab-indicator">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 단독 설문 나의 설문 목록 컴포넌트
 *
 * @author minkyoung.park@emcast.com
 * @author 
 * @since 2020.01.08
 */


// Google Material 컴포넌트 선언
import {MDCTabBar, MDCTabBarFoundation} from '@material/tab-bar'

export default {
    props: ['setTabFixed'],
    data() {
        return {
            surveyViewTab: null,
            tabType: 'Information',
        }
    },
    mounted() {
        this.surveyViewTab = new MDCTabBar(document.querySelector('#examViewSubTab'))
    },

    updated() {
        this.surveyViewTab = new MDCTabBar(document.querySelector('#examViewSubTab'))

        if (this.tabType === 'Information') {
            this.surveyViewTab.activateTab(0)
        }else if (this.tabType === 'Reward') {
            this.surveyViewTab.activateTab(1)
        }else {
            this.surveyViewTab.activateTab(0)
        }
    },

    computed: {
       isTabType() {
           return this.tabType
       }
    },

    methods: {
        changeTabType(type) {
            this.tabType = type
            this.$emit('setViewTab', type)
        }
        
    }

}
</script>

<style scoped>

</style>